export const RESET = 'EXCMDEVICE_LIST_RESET'
export const SET_ITEMS = 'EXCMDEVICE_LIST_SET_ITEMS'
export const SET_ERROR = 'EXCMDEVICE_LIST_SET_ERROR'
export const SET_VIEW = 'EXCMDEVICE_LIST_SET_VIEW'
export const TOGGLE_LOADING = 'EXCMDEVICE_LIST_TOGGLE_LOADING'
